module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_9016.de8d1a43.png";